import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { Icon } from 'semantic-ui-react'
import './css/footer.css'

function footer () {
  return (
    <div className='foot'>
      <Container>
        <Row className='row1'>
          <h2>Stay Connected! Stay safe!</h2>
        </Row>
        <Row className='justify-content-center col-md-12'>
          <Col>
            <a target='_blank' rel='noopener noreferrer' href='mailto:abhinav.022000@gmail.com'>
              <Icon name='mail' size='big' />
            </a>
          </Col>
          <Col>
            <a target='_blank' rel='noopener noreferrer' href='https://instagram.com/abhinavsri360'>
              <Icon name='instagram' size='big' />
            </a>
          </Col>
          <Col>
            <a target='_blank' rel='noopener noreferrer' href='https://t.me/abhinavsri360'>
              <Icon name='telegram' size='big' />
            </a>
          </Col>
          <Col>
            <a target='_blank' rel='noopener noreferrer' href='https://www.linkedin.com/in/abhinav-srivastava-a9b238172/'>
              <Icon name='linkedin' size='big' />
            </a>
          </Col>
          <Col>
            <a target='_blank' rel='noopener noreferrer' href='https://twitter.com/abhinavsri360'>
              <Icon name='twitter' size='big' />
            </a>
          </Col>
          <Col>
            <a target='_blank' rel='noopener noreferrer' href='https://abhinavsri360.github.io/'>
              <Icon name='globe' size='big' />
            </a>
          </Col>
          <Col>
            <a target='_blank' rel='noopener noreferrer' href='https://github.com/abhinavsri360'>
              <Icon name='github' size='big' />
            </a>
          </Col>
          <Col>
            <a target='_blank' rel='noopener noreferrer' href='https://dev.to/abhinavsri360'>
              <img src='https://d2fltix0v2e0sb.cloudfront.net/dev-badge.svg' alt="Abhinav Srivastava's DEV Profile" height='30' width='30' />
            </a>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default footer
